import Route from '@ember/routing/route';
import { service } from '@ember/service';
import { findRecord } from '@warp-drive/utilities/json-api';
// This is for types. Anything we have custom may show an error.
import type { Store as StoreService } from '@warp-drive/core';
import type { PslfFormExtension as PslfFormModel } from 'tio-data/data/resources/pslf-form.ext';

export default class AuthenticatedAdminPslfFormSuccessRoute extends Route {
  @service declare store: StoreService;

  async model(params: { form_id: string }) {
    const { content } = (await this.store.request(
      findRecord<PslfFormModel>('pslf-form', params.form_id, { reload: true })
    )) as { content: { data: PslfFormModel } };
    return content.data;
  }
}
